module.exports = __webpack_public_path__ + "img/egg_spirals.b61ad755.svg";